import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { firestore } from '../../firebase';

export const addUser = createAsyncThunk('users/addUser', async (userData) => {
  try {
    const auth = getAuth();
    const userCredential = await createUserWithEmailAndPassword(auth, userData.email, userData.password);
    const user = userCredential.user;
    
    const { password, confirmPassword, ...userDataWithoutPassword } = userData;

    const usersRef = firestore.collection('users'); 
    const newUserRef = await usersRef.add({
      ...userDataWithoutPassword,
      userId: user?.uid, 
    });

    const userId = newUserRef.id;
    const newUser = { id: userId, ...userDataWithoutPassword };

    return newUser;
  } catch (error) {
    console.error('Error creating user and adding user details:', error);
    throw error;
  }
});

  
export const fetchUsers = createAsyncThunk('users/fetchUsers', async (currentUserUid) => {
  const usersRef = firestore.collection('users');
  const snapshot = await usersRef.where('universityUid', '==', currentUserUid).get();
  const users = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  return users;
});


export const updateUser = createAsyncThunk('users/updateUser', async ({ uid, updatedUserData }) => {
  console.log("updateUser");
  console.log("moussa");
  console.log(uid);
  console.log(updatedUserData);
  try {
    const usersRef = firestore.collection('users');
    await usersRef.doc(uid).update(updatedUserData);

    return { id: uid, ...updatedUserData };
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
});